import BrushRounded from "@mui/icons-material/BrushRounded";
import { type FC, useCallback } from "react";
import { config } from "../../../../../config";
import { useBrandKit } from "../../../../brand-kit/hooks/use-brand-kit";
import { useClaims } from "../../../../generic/hooks/use-claims";
import { useInsertDesignHuddleEditor } from "../use-insert-design-huddle-editor";
import type { ToolbarProps } from "./props";
import { ToolbarIconButton } from "./toolbar-icon-button";

export const DesignHuddleButton: FC<ToolbarProps & { label?: string }> = ({
  disabled,
  label,
  onClick,
}) => {
  const user = useClaims();
  const { branding } = useBrandKit();

  const insertEditor = useInsertDesignHuddleEditor();

  const handleClick = useCallback(() => {
    onClick?.();
    void insertEditor(config.design_huddle.base_template_name, {
      ...branding,
      branding_type: { type: "standard", value: "bold" },
      default_tone: "professional",
    }).catch(console.error);
  }, [onClick, insertEditor, branding]);

  if (!user) return null;
  return (
    <ToolbarIconButton
      data-analytics-id="lexical-toolbar-design-huddle"
      disabled={disabled}
      label={label}
      data-testid="toolbar-button-design-huddle"
      aria-label="Image"
      tabIndex={-1}
      icon={<BrushRounded fontSize="medium" />}
      onClick={handleClick}
    />
  );
};
